<section class="facet-filter">
  <a role="button" class="facet-date_de-collapse-button facet-toggle collapsed"
     (click)="changeCreationDateCollapseForTablet()"
     [attr.aria-expanded]="activeCreationDateCollapseTablet" aria-controls="facet-date_de-collapse">
    <h2>{{ 'date.create' | translate }}<i class="fa fa-angle-down"></i></h2>
  </a>
  <h2 title="{{ 'date.create' | translate }}" class="facet-header" [attr.aria-label]="'date.create' | translate">{{ 'date.create' | translate }}</h2>
  <div id="facet-date-collapse" class="collapse facet-collapse"
       [ngClass]="(activeCreationDateCollapseTablet)?'in':''">
    <nav [attr.aria-label]="'date.selection' | translate">
      <dp-date-picker class="search-doc-date" aria-hidden="true" placeholder="{{ 'global.from' | translate }}: {{datePickerConfig.format}}" theme="dp-material"
                      [(ngModel)]="selectedCreationDateFrom" [config]="datePickerConfig"
                      (onSelect)="getCreationDateFrom()" (keyup.enter)="updateEmptyCreationDateData()">
      </dp-date-picker>
      <input (keyup.enter)="getCreationDateFromFromEvent($event)" [ngModel]="selectedCreationDateFrom | date: 'dd.MM.yyyy'"
             placeholder="{{ 'global.from' | translate }}: {{datePickerConfig.format}}" type="text"
             tabindex="-1" class="sr-only" [attr.aria-label]="'date.from' | translate">

      <dp-date-picker aria-hidden="true" placeholder="{{ 'global.to' | translate }}: {{datePickerConfig.format}}" theme="dp-material"
                      [(ngModel)]="selectedCreationDateTo" [config]="datePickerConfig"
                      (onSelect)="getCreationDateTo()" (keyup.enter)="updateEmptyCreationDateData()">
      </dp-date-picker>
      <input (keyup.enter)="getCreationDateToFromEvent($event)" [ngModel]="selectedCreationDateTo | date: 'dd.MM.yyyy'"
             placeholder="{{ 'global.to' | translate }}: {{datePickerConfig.format}}" type="text"
             tabindex="-1" class="sr-only" [attr.aria-label]="'global.to' | translate">
    </nav>
  </div>
</section>
